<template>
  <material-card
    :size.sync="internalSize"
    :order.sync="internalOrder"
    :maxOrderValue="maxOrderValue"
    @remove-widget="$emit('remove-widget', $event)"
    @add-widget="$emit('add-widget', $event)"
    :widgetId="widgetId"
    color="primary"
    dark
  >
    <v-progress-circular
      class="mt-16"
      size="50"
      v-if="loading"
      indeterminate
    ></v-progress-circular>
    <v-col
      v-else
      class="pa-0 card-link"
      @click.stop="$router.push('member-information')"
    >
      <v-card
        flat
        height="50%"
        width="100%"
        color="primary"
        class="white--text rounded-b-0"
        style="position: absolute; top: 0"
      >
        <v-col
          cols="12"
          class="text-left text-uppercase text-h6 pa-5 pb-2 pl-8"
          align-self="center"
        >
          <v-icon large>mdi-checkbox-marked-circle-outline</v-icon>
          {{
            $t(
              `components.vue_material_dashboard.items.member_information.${
                memberData &&
                memberData.MemberGroup &&
                memberData.MemberGroup.toLowerCase().split(" ").join("")
              }`
            )
          }}
        </v-col>
        <v-col cols="8" class="float-right" style="font-size: 20px"
          ><span
            >{{
              $t(
                "components.vue_material_dashboard.items.member_information.since"
              )
            }}:</span
          >
          May 27, 1997</v-col
        >
      </v-card>
      <v-card
        flat
        width="100%"
        height="50%"
        class="white secondary--text rounded-t-0"
        style="position: absolute; bottom: 0"
      >
        <v-row no-gutters justify="end">
          <v-col cols="9" class="text-h6 pa-0 pt-2">
            {{ memberData.FirstName + " " + memberData.LastName }}
          </v-col>
          <v-col cols="9" class="text-subtitle-2 pa-0 font-weight-light"
            >{{
              $t(
                "components.vue_material_dashboard.items.member_information.certificate"
              )
            }}: <strong>{{ memberData.Certificate }}</strong></v-col
          >
          <v-col cols="9" class="text-subtitle-2 pa-0 font-weight-light"
            >{{
              $t(
                "components.vue_material_dashboard.items.member_information.dob"
              )
            }}: <strong>{{ memberData.Dob }}</strong></v-col
          >
        </v-row>
      </v-card>
    </v-col>
    <v-avatar
      class="avatar"
      :size="$vuetify.breakpoint.mdAndUp ? 95 : 75"
      v-show="memberData.FirstName"
      color="white"
    >
      <img
        v-if="memberData.Image"
        :src="'data:image/jpg;base64,' + memberData.Image"
        alt="member-img"
      />
      <v-avatar v-else color="secondary" size="93">
        <span class="text-h4">
          {{
            memberData.FirstName &&
            memberData.FirstName.charAt(0) +
              (memberData.LastName && memberData.LastName.charAt(0))
          }}
        </span>
      </v-avatar>
    </v-avatar>
  </material-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MaterialCard from "@/components/VueMaterialDashboard/material/MaterialCardDashboard.vue";
export default {
  components: {
    MaterialCard,
  },
  props: {
    widgetId: String,
    size: Number,
    order: Number,
    maxOrderValue: Number,
  },
  data() {
    return {
      internalSize: undefined,
      internalOrder: undefined,
      selectedItem: undefined,
      memberData: {},
      loading: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  watch: {
    size: {
      handler(v) {
        this.internalSize = v;
      },
    },
    internalSize: {
      handler(v) {
        this.$emit("update:size", v);
      },
    },
    order: {
      handler(v) {
        this.internalOrder = v;
      },
    },
    internalOrder: {
      handler(v) {
        this.$emit("update-order", v);
      },
    },
  },
  mounted() {
    if (this.size !== null && this.size !== undefined) {
      this.internalSize = this.size;
    }
    if (this.order !== null && this.order !== undefined) {
      this.internalOrder = this.order;
    }
    this.loadData();
  },
  methods: {
    ...mapActions("data", ["getMemberData"]),
    async loadData() {
      try {
        this.loading = true;
        this.memberData = (
          await this.getMemberData({
            planIdentityId: this.user.plan,
            memberIdentityId: this.user.sub,
          })
        ).data;
        this.loading = false;
      } catch (error) {
        this.error = error;
        console.log(error);
        this.memberData = {
          FirstName: "Henry",
          LastName: "Foster",
          MemberGroup: "Active Member",
          CellPhone: "6972281493",
          EmailAddress: "henry.foster@gmail.com",
          Dob: "May, 27, 1997",
          Certificate: 247000345,
          Image:
            "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",
        };
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.avatar {
  position: absolute;
  top: 75px;
  left: 30px;
  border: 3px white solid;
}
.card-link {
  cursor: pointer;
}
</style>
